import type { SignupDraft } from './draft';

/**
 * An invite link fills in what Dale already knows about the business:
 * `/registro?negocio=Barbería%20Sol&correo=sol@barberia.pa&tel=6123-4567`.
 * Plain prefill of the draft, nothing more: each value is trimmed, capped and
 * dropped when it does not look like what it says, the person can change
 * every one, and the server validates the signup as it always does.
 */

/** Same ceilings the signup API enforces. */
const MAX_BUSINESS_NAME = 120;
const MAX_EMAIL = 254;
const MAX_PHONE = 20;
const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** What a phone is written with; anything else is dropped. */
const NOT_PHONE_CHARACTER = /[^\d+\-() ]/g;
const HAS_DIGIT = /\d/;

export type InvitePrefill = Partial<Pick<SignupDraft, 'businessName' | 'email' | 'phone'>>;

function businessNameFrom(raw: string | null): string | undefined {
  const value = raw?.trim().slice(0, MAX_BUSINESS_NAME).trim();
  return value ? value : undefined;
}

function emailFrom(raw: string | null): string | undefined {
  const value = raw?.trim().toLowerCase();
  return value && value.length <= MAX_EMAIL && EMAIL_SHAPE.test(value) ? value : undefined;
}

function phoneFrom(raw: string | null): string | undefined {
  const value = raw?.replace(NOT_PHONE_CHARACTER, '').replace(/\s+/g, ' ').trim().slice(0, MAX_PHONE).trim();
  return value && HAS_DIGIT.test(value) ? value : undefined;
}

export function readInvitePrefill(search: string): InvitePrefill {
  const params = new URLSearchParams(search);
  const businessName = businessNameFrom(params.get('negocio'));
  const email = emailFrom(params.get('correo'));
  const phone = phoneFrom(params.get('tel'));
  return {
    ...(businessName ? { businessName } : {}),
    ...(email ? { email } : {}),
    ...(phone ? { phone } : {}),
  };
}
